import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

interface ToasterProps {
  uploadProgressSlot?: React.ReactNode
}

export function Toaster({ uploadProgressSlot }: ToasterProps) {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, duration, showProgress, ...props }) {
        return (
          <Toast key={id} duration={duration} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
            {showProgress && duration && duration !== Infinity && (
              <div className="absolute bottom-0 left-0 right-0 h-1 overflow-hidden rounded-b-md">
                <div
                  className="h-full bg-white/30"
                  style={{
                    animation: `toast-progress ${duration}ms linear forwards`
                  }}
                />
              </div>
            )}
          </Toast>
        )
      })}
      <ToastViewport uploadProgressSlot={uploadProgressSlot} />
    </ToastProvider>
  )
}
